import template from './recovery-success.html';
import controller from './recovery-success.controller';
import './recovery-success.scss';

let RecoverySuccessComponent = {
  bindings: {},
  template,
  controller
};

export default RecoverySuccessComponent;



// WEBPACK FOOTER //
// ./src/app/pages/recovery-success/recovery-success.component.js